import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SessionStore } from '../services/SessionStore';
import { useAuth } from 'oidc-react';
import { useDispatch } from 'react-redux';
import { setAuthState } from '../store/states/ConfigurationSlice';

export const Logout = () => {
  const { t } = useTranslation();

  const auth = useAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    // Remove all session keys except those containing 'oidc.user'
    Object.keys(SessionStore.store)
      .filter((key) => !key.includes('oidc.user'))
      .forEach((key) => SessionStore.remove(key));

    //logout from the oidc after redirect to the logout page
    auth.signOut();
    dispatch(setAuthState({ authState: 'logout' }));
  }, []);

  return <h4>{t('labels.logoutMessage')}</h4>;
};
